import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button/Button';
import { Body } from '../../styled components/Typography';
import NavigationHistory from '../../libs/NavigationHistory';

/**
 * Show the server state errors on an event detail.
 */

const GenericError = (props) => {
  const { errorCode, navigationHistory, message401, message403, message404 } = props;
  let message = i18n('Something went wrong…');
  let emoticon = `😯`;
  if (errorCode === 400) {
    message = i18n('Could not process the API request.');
    emoticon = `😯`;
  }
  if (errorCode === 401) {
    message = message401;
    emoticon = `😎`;
  }
  if (errorCode === 403) {
    message = message403;
    emoticon = `😎`;
  }
  if (errorCode === 404) {
    message = message404;
    emoticon = `🧐`;
  }
  if (errorCode === 429) {
    message = i18n('The request to the API timed out.');
    emoticon = `🧐`;
  }
  if (errorCode === 502) {
    message = i18n('Could not connect to Yesplan.');
    emoticon = `🧐`;
  }
  if (errorCode === 503) {
    message = i18n('Could not connect to Yesplan.');
    emoticon = `🧐`;
  }
  return (
    <>
      <div tw="p-16 pt-48">
        <div tw="mb-24 text-center">
          <p tw="mb-4">
            <span role="img" aria-label="">
              {emoticon}
            </span>
          </p>
          <Body tw="text-black text-opacity-60">{message}</Body>
        </div>
        <div tw="flex justify-center">
          <Button
            variant="outlined"
            contentType="textWithIcon"
            color="primary"
            icon="navigate-before"
            iconPosition="left"
            size="medium"
            onClick={(e) => {
              e.preventDefault();
              navigationHistory.goBack();
            }}
          >
            {i18n('Go Back')}
          </Button>
        </div>
      </div>
    </>
  );
};

GenericError.propTypes = {
  errorCode: PropTypes.oneOf(['', 400, 401, 403, 404, 429, 502, 503]),
  message401: PropTypes.string.isRequired,
  message403: PropTypes.string.isRequired,
  message404: PropTypes.string.isRequired,
  navigationHistory: PropTypes.instanceOf(NavigationHistory).isRequired
};

export default GenericError;
